<template>
    <SquareBtn color="default"
               size="lg"
               @click="click">
        <i class="fa-solid fa-left"></i>
        {{ l('BACK') }}
    </SquareBtn>
</template>

<script setup>
import SquareBtn from '@/vue/components/SquareBtn';

const click = () => {
    window.history.back();
};
</script>
